import {
	FormSectionCard,
	GradientText,
	SubmitButton,
	SubmitButtonContainer,
	Wrapper,
} from '../PasserCommande/PasserCommande.styles'
import React, { useEffect, useState } from 'react'
import { getSingleClient, updateClientAccount } from '../../api/clients'
import { useDispatch, useSelector } from 'react-redux'
import Switch from 'react-switch'
import Container from '../../Components/LayoutClient/container.component'
import { CustomInput } from '../RegisterTransporter/style'
import File from '../../assets/img/file@2x.png'
import Modal from 'react-modal'
import { BASE_URL } from '../../api/base'
import UploadFile from '../../Components/UploadSingleFile/upload.component'
import toast from 'react-hot-toast'
import { updateProfile } from '../../redux/auth'
import { useForm, Controller } from 'react-hook-form'
import { useHistory } from 'react-router'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { validatePhoneNumber } from '../../utils/phoneValidator'
import { useAuthenticatedFetch } from '../../hooks'
import { useTranslation } from 'react-i18next'

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root')

function ClientAccount() {
	const { _id } = useSelector((state) => state.auth.user)
	const [loading, setLoading] = useState(false)
	const history = useHistory()
	const dispatch = useDispatch()

	const {
		register,
		handleSubmit,
		setValue,
		reset,
		control,
		formState: { errors },
	} = useForm()

	const [client, setClient] = useState()
	const [chargementEnCours, setChargementEnCours] = useState(false);
	const token = useSelector((state) => state.auth.token);
	const [fileUrls, setFileUrls] = useState({})
	const [fileLoading, setFileLoading] = useState({})
	const { t } = useTranslation()
	const {
		fetchResource,
		error: fetchError,
		loading: fetchLoading,
	} = useAuthenticatedFetch()


	// Charger les URLs signées pour les fichiers
	const loadFileUrls = async () => {
		if (!client) return;

		const urls = {};
		const loadingStates = {};
		const fileFields = ['logo', 'kbis', 'piece_identite'];

		for (const field of fileFields) {
			const file = client[field];
			if (file && file.path) {
				loadingStates[field] = true;
				try {
					const url = await fetchResource(file.path, token);
					urls[field] = url;
				} catch (error) {
					console.error(`Error loading ${field}:`, error);
				} finally {
					loadingStates[field] = false;
				}
			}
		}

		setFileUrls(prev => ({ ...prev, ...urls }));
		setFileLoading(prev => ({ ...prev, ...loadingStates }));
	}
	async function fetchClient(_id) {
		setChargementEnCours(true)
		try {
			const data = await getSingleClient(_id, token)
			setClient(data)
			reset({
				quality: data?.quality,
				address: data?.address,
				city: data?.city,
				postalCode: data?.postalCode,
				phone: data?.phone
			})


		} catch (error) {
			toast.error(t("transfer_request_err"), {
				style: {
					fontFamily: 'Montserrat',
				},
			});
		} finally {
			setChargementEnCours(false)
		}



	}
	useEffect(() => {
		fetchClient(_id)
	}, [_id])

	useEffect(() => {
		if (client) {
			loadFileUrls();
		}
	}, [client])



	const onSubmit = async (data) => {
		setLoading(true)



		const modifiableData = {

			quality: data.quality,
			address: data.address,
			city: data.city,
			postalCode: data.postalCode,
			phone: data.phone,
			password: data.password,
		}
		if (modifiableData.password.length === 0) {
			delete modifiableData.password
		}
		const modifiedFiles = [];
		const fileFields = [
			'kbis',
			'logo',
			'piece_identite'
		];
		fileFields.forEach(field => {
			if (data[field]) {
				modifiedFiles.push({
					[field]: data[field]
				});
			}
			delete data[field];

		});
		try {


			const res = await updateClientAccount(_id, modifiableData, modifiedFiles, token)

			toast.success(t("account_updated"), {
				style: {
					fontFamily: 'Montserrat',
				},
			})

			dispatch(updateProfile(res))
			fetchClient(_id)
		} catch (error) {
			toast.error(t("transfer_request_err"), {
				style: {
					fontFamily: 'Montserrat',
				},
			})
		} finally {
			setLoading(false)
		}
	}
	const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 768);


	useEffect(() => {
		const checkIfMobile = () => {
			setSmallScreen(window.innerWidth < 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);
	return (
		<Container>
			<div style={{
				width: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexDirection: 'column',
				paddingBottom: '4rem',
				paddingLeft: '1.5rem',
				paddingRight: '1.5rem',
			}}
			>
				<Wrapper>
					<GradientText style={{
						fontSize: isSmallScreen ? '2rem' : '2.5rem'
					}}>{t("my_account").toUpperCase()}</GradientText>
				</Wrapper>
				{chargementEnCours ?
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							backgroundColor: 'white',
							marginTop: "3rem",
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,

						}}
					>
						<div className='customLoader'></div>
					</div>
					:
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							width: '100%',
						}}
					>
						<div
							style={{
								width: '100%',
								fontFamily: 'Montserrat',
								alignSelf: 'center',
							}}
						>
							<div>

								{client?.premium && (
									!client.paymentMethodId &&

									<button
										style={{
											padding: '1rem',
											borderRadius: '0.3rem',
											background: '#50f5a9',
											color: "white",
											border: 'none',
											marginTop: '1rem',
											fontFamily: 'Montserrat',
											fontWeight: 'bold',
											cursor: 'pointer'

										}}
										onClick={() => { history.push(`/client/card`) }}
									>
										{t("save_your_payment_information")}
									</button>
								)}
							</div>
							<form onSubmit={handleSubmit(onSubmit)}>
								<FormSectionCard>
									<div
										style={{
											display: 'flex',
											flexDirection: isSmallScreen ? 'column' : 'row',

										}}
									>
										<div
											style={{
												width: isSmallScreen ? '100%' : '50%',
												display: 'flex',
												flexDirection: 'column',
												paddingBottom: '2rem',
											}}
										>
											<span
												style={{
													color: '#262626',
													paddingBottom: '1rem',
												}}
											>
												{t("company_name")}
											</span>
											<CustomInput
												type='text'
												disabled
												placeholder='Wayne'
												defaultValue={client?.societe}
												style={{
													backgroundColor: '#f0f0f0',
													color: '#a9a9a9',
													cursor: 'not-allowed'
												}}
											/>
										</div>
										<div style={{ width: '1rem' }} />
										<div
											style={{
												width: isSmallScreen ? '100%' : '50%',
												display: 'flex',
												flexDirection: 'column',
												paddingBottom: '2rem',
											}}
										>
											<span
												style={{
													color: '#262626',
													paddingBottom: '1rem',
												}}
											>
												SIRET
											</span>
											<CustomInput
												type='text'
												disabled
												placeholder='833 543 509 000'
												defaultValue={client?.siret}
												style={{
													backgroundColor: '#f0f0f0',
													color: '#a9a9a9',
													cursor: 'not-allowed'
												}}
											/>
										</div>
									</div>
									<div
										style={{
											display: 'flex',
											flexDirection: isSmallScreen ? 'column' : 'row',
										}}
									>
										<div
											style={{
												width: isSmallScreen ? '100%' : '50%',
												display: 'flex',
												flexDirection: 'column',
												paddingBottom: '2rem',
											}}
										>
											<span
												style={{
													color: '#262626',
													paddingBottom: '1rem',
												}}
											>
												{t("last_name")}
											</span>
											<CustomInput
												disabled
												type='text'
												placeholder='Doe'
												defaultValue={client?.last_name}
												style={{
													backgroundColor: '#f0f0f0',
													color: '#a9a9a9',
													cursor: 'not-allowed'
												}}
											/>
										</div>

										<div style={{ width: '1rem' }} />

										<div
											style={{
												width: isSmallScreen ? '100%' : '50%',
												display: 'flex',
												flexDirection: 'column',
												paddingBottom: '2rem',
											}}
										>
											<span
												style={{
													color: '#262626',
													paddingBottom: '1rem',
												}}
											>
												{t("first_name")}
											</span>
											<CustomInput
												type='text'
												placeholder='John'
												disabled
												defaultValue={client?.first_name}
												style={{
													backgroundColor: '#f0f0f0',
													color: '#a9a9a9',
													cursor: 'not-allowed'
												}}
											/>
										</div>
									</div>

									<div
										style={{
											display: 'flex',
											flexDirection: isSmallScreen ? 'column' : 'row',
										}}
									>
										<div
											style={{
												width: isSmallScreen ? '100%' : '50%',
												display: 'flex',
												flexDirection: 'column',
												paddingBottom: '2rem',
											}}
										>
											<span
												style={{
													color: '#262626',
													paddingBottom: '1rem',
												}}
											>
												{t("quality")}
											</span>
											<Controller
												name="quality"
												control={control}
												defaultValue={client?.quality}
												rules={{
													required: t("enter_job_position"),
													minLength: {
														value: 3,
														message: t("article_f") + t("quality") + t("err_message2"),
													},
													pattern: {
														value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s'\-]+$/,
														message: t("article_f") + t("quality") + t("err_message2")
													},
												}}
												render={({ field }) => (
													<CustomInput
														type="text"
														placeholder={t("operations_director")}
														{...field}
													/>
												)}
											/>

											{errors.quality && (
												<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
													{errors.quality.message}
												</div>
											)}
										</div>

										<div style={{ width: '1rem' }} />

										<div
											style={{
												width: isSmallScreen ? '100%' : '50%',
												display: 'flex',
												flexDirection: 'column',
												paddingBottom: '2rem',
											}}
										>
											<span
												style={{
													color: '#262626',
													paddingBottom: '1rem',
												}}
											>
												{t("sector")}
											</span>
											<CustomInput
												type='text'
												disabled
												placeholder='Transport frigorifique'
												defaultValue={client?.domain}
												style={{
													backgroundColor: '#f0f0f0',
													color: '#a9a9a9',
													cursor: 'not-allowed'
												}}
											/>
										</div>
									</div>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											{t("country")}
										</span>
										<CustomInput
											type='text'
											disabled
											defaultValue={client?.pays?.label}
											style={{
												backgroundColor: '#f0f0f0',
												color: '#a9a9a9',
												cursor: 'not-allowed'
											}}
										/>
									</div>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											{t("address")}
										</span>
										<Controller
											name="address"
											control={control}
											defaultValue={client?.address}
											rules={{
												required: t("enter_address"),
												minLength: {
													value: 3,
													message: t("article_elided") + t("address") + t("err_message2"),
												},
												pattern: {
													value: /^[A-Za-zÀ-ÿ0-9\s',.\-/()°]+$/,
													message: t("article_elided") + t("address") + t("err_message3"),

												},
											}}
											render={({ field }) => (
												<CustomInput
													type='text'
													placeholder='54 rue avenue de la grande armée, 75017, Paris, France'
													{...field}
												/>
											)}
										/>
										{errors.address && (
											<div style={{ color: 'red', marginTop: '0.5rem', fontSize: "14px" }}>
												{errors.address.message}
											</div>
										)}
									</div>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											{t("city")}
										</span>
										<Controller
											name="city"
											control={control}
											defaultValue={client?.city}
											rules={{
												required: t("enter_city"),
											minLength: {
												value: 3,
												message: t("article_f") +t("city") +t("err_message2"),
											},
											pattern: {
												value: /^.+$/,
												message: t("article_f") +t("city") +t("err_message3"),
											},
											}}
											render={({ field }) => (
												<CustomInput
													type='text'
													placeholder='54 rue avenue de la grande armée, 75017, Paris, France'
													{...field}
												/>
											)}
										/>
										{errors.city && (
											<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
												{errors.city.message}
											</div>
										)}
									</div>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											{t("zip_code")}
										</span>
										<Controller
											name="postalCode"
											control={control}
											defaultValue={client?.postalCode}
											rules={{
												required: t("enter_postal_code"),
											pattern: {
												value: /^\d{5}$/,
												message: t("zip_code_err_message"),
											},
											}}
											render={({ field }) => (
												<CustomInput
													type='text'
													placeholder='75017'
													{...field}
												/>
											)}
										/>
										{errors.postalCode && (
											<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
												{errors.postalCode.message}
											</div>
										)}
									</div>

									<div
										style={{
											width: isSmallScreen ? '100%' : '50%',
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											{t("contact_us_formulair_item2")}
										</span>
										<Controller
											name="phone"
											control={control}
											defaultValue={client?.phone}
											rules={{
												validate: validatePhoneNumber
											}}
											render={({ field }) => (
												<PhoneInput
													country={'fr'}
													value={field.value}
													onChange={(phone, countryData) => {
														field.onChange(phone);
													}}
													inputProps={{
														name: field.name,
														required: true,
													}}
													inputStyle={{
														paddingRight: '1.5rem',
														paddingTop: '1.5rem',
														paddingBottom: '1.5rem',
														borderRadius: '0.5rem',
														border: 'none',
														fontFamily: 'Montserrat',
														color: '#858ea8',
														flex: '1',
														display: 'flex',
														width: '100%',
													}}
													buttonStyle={{
														borderRadius: '0.5rem',
														border: 'none',
														fontFamily: 'Montserrat',
														color: '#858ea8',
														flex: '1',
														display: 'flex',
													}}

													containerStyle={{
														width: '100%',
													}}
													placeholder="(0) 01 45 66 32 88"
													enableSearch={true}
													searchPlaceholder={t("search_for_country")}
												/>
											)}
										/>
										{errors.phone && (
											<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
												{errors.phone.message}
											</div>
										)}
									</div>

									<div
										style={{
											display: 'flex',
											flexDirection: isSmallScreen ? 'column' : 'row',
										}}
									>
										<div
											style={{
												width: isSmallScreen ? '100%' : '50%',
												display: 'flex',
												flexDirection: 'column',
												paddingBottom: '2rem',
											}}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
												}}
											>
												<span
													style={{
														color: '#262626',
														paddingBottom: '1rem',
													}}
												>
													{t("change_password")}
												</span>
											</div>
											<CustomInput
												type='password'
												//disabled
												autoComplete='new-password'
												placeholder={t("password_placeholder")}
												{...register('password', {
													minLength: 8,
												})}
											/>
										</div>


										<div style={{ width: '1rem' }} />
										<div
											style={{
												width: isSmallScreen ? '100%' : '50%',
												display: 'flex',
												flexDirection: 'column',
												paddingBottom: '2rem',
											}}
										>

											<span

												style={{
													color: '#262626',
													paddingBottom: '1rem',
												}}
											>
												TVA
											</span>
											<Switch
												checked={client?.tva}
												offColor='#F3F6F9'
												onColor='#F3F6F9'
												checkedIcon={false}
												uncheckedIcon={false}
												offHandleColor='#BFBFBF'
												onHandleColor='#168EEA'
												height={40}
												width={80}
												boxShadow='0px 5px 7px 0px rgba(0,0,0,0.23)'
												disabled
											/>


										</div>

									</div>

									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											marginBottom: '1rem',
											width: '100%',
											fontFamily: 'Montserrat',
											marginTop: 10,
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
												justifyContent: 'space-between',
											}}
										>
											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
												}}
											>
												Logo(PNG {t("or")} JPG)
											</span>
											<span
												style={{
													marginBottom: '1rem',
													color: '#838EAB',
													fontSize: 14,
												}}
											>
												({t("optional")})
											</span>
										</div>

										<Controller
											name='logo'
											control={control}
											render={({ field }) => (
												<UploadFile
													name={field.name}
													accept={'.jpg, .png'}
													setValue={setValue}
													{...field}
												/>
											)}
										/>
										<Controller
											name='logo'
											control={control}
											render={({ field }) => (
												<UploadFile
													name={field.name}
													accept={'.jpg, .png'}
													setValue={setValue}
													{...field}
												/>
											)}
										/>
										{client?.logo && client.logo.mimetype !== 'application/pdf' && (
											<>
												{fileLoading.logo ? (
													<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 100 }}>
														<div className='customLoader' style={{ transform: 'scale(0.5)' }}></div>
													</div>
												) : (
													<img
														style={{ width: 100, height: 100, borderRadius: 5, objectFit: 'cover' }}
														src={fileUrls.logo || `${BASE_URL}/${client.logo.path}`}
														alt="Logo"
													/>
												)}
											</>
										)}
										{client?.logo && client.logo.mimetype === 'application/pdf' && (
											<div style={{ display: 'flex', flexDirection: 'row', overflow: 'hidden', overflowWrap: 'anywhere' }}>
												<img src={File} style={{ height: 20, marginRight: '1rem' }} alt="PDF icon" />
												<span
													style={{ cursor: 'pointer' }}
													onClick={() => window.open(fileUrls.logo || `${BASE_URL}/${client.logo.path}`)}
												>
													{client.logo.name}
												</span>
											</div>
										)}
									</div>

									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											width: '100%',
											fontFamily: 'Montserrat',
											marginTop: 10,
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
												justifyContent: 'space-between',
											}}
										>
											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
												}}
											>
												KBIS (PDF)
											</span>
											<span
												style={{
													marginBottom: '1rem',
													color: '#838EAB',
													fontSize: 14,
												}}
											>
												({t("optional")})
											</span>
										</div>

										<Controller
											name='kbis'
											control={control}
											render={({ field }) => (
												<UploadFile
													name={field.name}
													accept={'.pdf'}
													setValue={setValue}
													{...field}
												/>
											)}
										/>
										{client?.kbis && (
											<div style={{ display: 'flex', flexDirection: 'row', overflow: 'hidden', overflowWrap: 'anywhere' }}>
												<img src={File} style={{ height: 20, marginRight: '1rem' }} alt="PDF icon" />
												{fileLoading.kbis ? (
													<div style={{ display: 'flex', alignItems: 'center' }}>
														{t("loading")}...
													</div>
												) : (
													<span
														style={{ cursor: 'pointer', color: '#007bff' }}
														onClick={() => window.open(fileUrls.kbis || `${BASE_URL}/${client.kbis.path}`)}
													>
														{client.kbis.name}
													</span>
												)}
											</div>
										)}
									</div>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											width: '100%',
											fontFamily: 'Montserrat',
											marginTop: 10,
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
												justifyContent: 'space-between',
											}}
										>
											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
												}}
											>
												{t("id_card")} (PDF)
											</span>
										</div>

										<Controller
											name='piece_identite'
											control={control}
											render={({ field }) => (
												<UploadFile
													name={field.name}
													accept={'.pdf'}
													setValue={setValue}
													{...field}
												/>
											)}
										/>
										{client?.piece_identite && (
											<div style={{ display: 'flex', flexDirection: 'row', overflow: 'hidden', overflowWrap: 'anywhere' }}>
												<img src={File} style={{ height: 20, marginRight: '1rem' }} alt="PDF icon" />
												{fileLoading.piece_identite ? (
													<div style={{ display: 'flex', alignItems: 'center' }}>
														{t("loading")}...
													</div>
												) : (
													<span
														style={{ cursor: 'pointer', color: '#007bff' }}
														onClick={() => window.open(fileUrls.piece_identite || `${BASE_URL}/${client.piece_identite.path}`)}
													>
														{client.piece_identite.name}
													</span>
												)}
											</div>
										)}
									</div>
								</FormSectionCard>
								<div style={{ height: '1rem' }} />
								<SubmitButtonContainer>
									<SubmitButton type='submit' disabled={loading}>
										{loading ? (
											<div className='loader'></div>
										) : (
											t("save")
										)}
									</SubmitButton>
								</SubmitButtonContainer>


							</form>
						</div>
					</div>
				}
			</div>
		</Container>
	)
}

export default ClientAccount
